import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const RevisionsRequested = new StatusEnumItem({
  id: 'A7B9C363-E121-4751-837C-7206DDCF5979',
  priority: 0,
  name: 'Revisions Requested',
  description: 'A router has determined the Submittal requires revisions',
})

const REReview = new StatusEnumItem({
  id: 'C6AABE38-B180-441D-9C5A-8CC2858FA336',
  priority: 3,
  name: 'RE Review',
  description: 'The Resident Engineer gives their final disposition',
})

const GroupReview = new StatusEnumItem({
  id: '1C1A7434-EA18-4850-8B19-273F662DB406',
  priority: 2,
  name: 'Group Review',
  description:
    'Routing Groups are checked off by Approvers before the Submittal may advance to RE Review',
})

const RouterReview = new StatusEnumItem({
  id: 'A33BECBC-738D-4BE7-B839-BD98030AD062',
  priority: 1,
  name: 'Router Review',
  description: `Routers review the current state of the Submittal to request revisions, route to ${GroupReview.name}, route to ${REReview.name}, or submit the Disposition`,
})

const Closed = new StatusEnumItem({
  id: '58F023E5-2AC0-4496-A9C2-F49BBD030AF0',
  priority: 4,
  name: 'Closed',
  description:
    'The Submittal has completely gone through the Submittal Tracker workflow. Its associated SharePoint folder is locked from editing',
})

const Unlocked = new StatusEnumItem({
  id: '64E9C579-9A6E-42B7-A625-E5DCADD6734E',
  priority: 5,
  name: 'Unlocked',
  description:
    'The Submittal has completely gone through the Submittal Tracker workflow, but its associated SharePoint folder is unlocked for editing',
})

export type CASStatusItem =
  | typeof RevisionsRequested
  | typeof REReview
  | typeof GroupReview
  | typeof RouterReview
  | typeof Closed
  | typeof Unlocked

class CASStatusEnum extends StatusEnum<
  'CASStatus',
  CASStatusItem,
  CASStatusItem['name'],
  CASStatusItem['id'],
  CASStatusItem['priority']
> {
  typename = 'CASStatus' as const
  readonly RevisionsRequested = RevisionsRequested
  readonly REReview = REReview
  readonly GroupReview = GroupReview
  readonly RouterReview = RouterReview
  readonly Closed = Closed
  readonly Unlocked = Unlocked
  get values() {
    return [
      this.RevisionsRequested,
      this.REReview,
      this.GroupReview,
      this.RouterReview,
      this.Closed,
      this.Unlocked,
    ]
  }
}

export const CASStatus = new CASStatusEnum()
